<template>
  <ion-avatar>
    <synced-image
      :src="avatar"
    />
  </ion-avatar>
</template>

<script>
import { IonAvatar } from '@ionic/vue';
import SyncedImage from '../image/SyncedImage.vue';

export default {
    components: {
        IonAvatar,
        SyncedImage,
    },
    data() {
        return {};
    },
    computed: {
        avatar() {
            return this.$store.getters.avatar(this.$store.getters.user_id);
        },
    },
};
</script>

<style scoped>
ion-avatar {
  --border-radius: 4px;
}
</style>
